/*       */

import { gql } from '@apollo/client';

// Reads the `llm` system-settings section, which holds the LLM providers list:
// { providers: [{ id, apiFormat, apiKey, baseUrl }] }
export default gql`
    query llmSettingsQuery {
        result: systemSettings(section: llm)
    }
`;
